<div class="diff-container" [innerHTML]="diffHtml | safeHtml"></div>
